import { TEMP_ID_TAG } from './constants'

export const setTempId = (name: string): string => {
  return `${TEMP_ID_TAG}${name}`
}

export const isTempId = (id: string | number): boolean =>
  typeof id === 'string' && id.includes(TEMP_ID_TAG)
